import React from 'react'

import { useZionCMS } from '../../providers/ZionCMSProvider'
import DynamicZionCMSComponent from './DynamicZionCMSComponent'

type ItemType = {
  __typename?: string
  modelType?: string
}

type RenderZionCMSItemProps = {
  item: ItemType | unknown
  alignY?: 'top' | 'middle' | 'bottom'
  columns?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12
  noGrowY?: boolean
}

export default function RenderZionCMSItem({ item }: RenderZionCMSItemProps): JSX.Element {
  const { customComponents } = useZionCMS()

  if (!item) return <></>

  const { __typename, modelType } = item as ItemType
  const theRealType = modelType || __typename || ''

  if (!theRealType) return <></>

  try {
    if (customComponents?.[theRealType]) {
      const Component = customComponents[theRealType]
      return <Component {...item} />
    }
    return <DynamicZionCMSComponent component={theRealType} {...item} />
  } catch (e) {
    console.error(
      `There was an error with rendering the item:\n\n${JSON.stringify(
        item,
        null,
        2
      )}.\n\nThe type for that item is: ${theRealType}\n\nError: ${e}`
    )

    // We could render something to give feedback on this error if needed
    return <></>
  }
}

type RenderZionCMSItemsProps = {
  items?: ItemType[] | unknown[]
  Separator?: JSX.Element
}

export function RenderZionCMSItems({ items = [], Separator }: RenderZionCMSItemsProps): JSX.Element {
  return (
    <>
      {items.map((item, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <React.Fragment key={index}>
          <RenderZionCMSItem item={item} />
          {!!Separator && index < items.length - 1 && Separator}
        </React.Fragment>
      ))}
    </>
  )
}
